<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';
import { getAddress } from '../../../mixins/getAddress';

export default {
    data() {
        return {
            disableOnSubmit : false,
            register: {
                type: null,
                gender: null,
                competition: null,
                image: null,
                learn_cricket: null,
                open_category : null,
                women_category: null,
                youth_category: null,
                social_category: null,
                parent_consent: null,
                spirit_of_cricket: null,
                disciplinary: null,
            },
        }
    },

    props: ['old_data', 'player_age', 'type'],

    mixins: [validateAndSubmit, validationClass, getAddress],

    computed: {
        isYouth : function(){
            return this.register.type == 'youth';
        },

        isSocial : function(){
            return this.register.type == 'social';
        },

        isPlayer : function (){
            return this.register.type == 'player';
        },

        isPlayerOrYouth : function (){
            return this.register.type == 'player' || this.register.type == 'youth';
        },

        hasCategory: function() {
            if (this.isSocial) {
                return false;
            }

            return !this.register.open_category && !this.register.women_category && !this.register.youth_category && !this.register.social_category ? false : true;
        },

        categoryErrors: function (){
            return this.errors.has('player-form.open_category')
                || this.errors.has('player-form.women_category')
                || this.errors.has('player-form.youth_category')
                || this.errors.has('player-form.social_category');
        },      
    },

    created() {
        for (var key in this.old_data) {
            if (this.old_data.hasOwnProperty(key) && this.register.hasOwnProperty(key) ) {
                if (key == 'type') {
                    this.register.type == key == 'youth' ? true : false;
                    continue;
                }

                this.register[key] = this.old_data[key];
            }
        }
    },

    mounted() {
        this.register.type = this.type;
    },

    watch: {
    },

    methods: {
        resetCompetitionCategories() {
            this.register.open_category = null;
            this.register.women_category = null;
            this.register.youth_category = null;
        }        
    },
}
</script>
